import { FC } from 'react';

import ExpandableText from 'components/expandableText/ExpandableText';
import { IShippingPolicyRow } from 'types';

const ShippingPolicyRow: FC<IShippingPolicyRow> = ({
  title,
  subTitle,
  description,
  isExpandableText,
}) => {
  return (
    <div className="ship-info-container">
      <span className="title">{title}</span>
      {isExpandableText && (
        <ExpandableText text={subTitle} maxChars={70} isCollapsable isTextClickable={false} />
      )}
      {!isExpandableText && <span className="sub-title">{subTitle}</span>}
      {description && <span className="description">{description}</span>}
    </div>
  );
};

export default ShippingPolicyRow;
